export default __webpack_public_path__ + "static/ManMusicNoLine-e2071d0f96c4dc5687b31a526e2acf10.png";